import ReactGA from "react-ga4";

const TRACKING_ID = "G-F19W1SH8V5";

export default function InitializeGoogleAnalytics() {
  ReactGA.initialize(TRACKING_ID);
}

function TrackGAUser(userId) {
  ReactGA.set({
    user_id: userId,
  });
}

function TrackGAPageView(page, title) {
  ReactGA.send({ hitType: "pageview", page: page, title: title });
}

const TrackGoogleAnalyticsEvent = (category, action, label) => {
  // Send GA4 Event
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

const setUserProperty = (nameValue) => {
  ReactGA.gtag("set", "user_properties", {
    user_name: nameValue,
  });
};

const useAnalyticsEventTracker = (category = "Blog category") => {
  const eventTracker = (
    action = "test action",
    label = "test label",
    value = undefined
  ) => {
    ReactGA.event({ category, action, label, value });
  };
  return eventTracker;
};

const selectTracker = (selectedOptionIds) => {
  const eventTracker = (action = "test action", label = "test label") => {
    ReactGA.event({
      category: "ingredients",
      action: "test",
      label: selectedOptionIds,
    });
  };
  return eventTracker;
};

export {
  InitializeGoogleAnalytics,
  TrackGoogleAnalyticsEvent,
  TrackGAUser,
  TrackGAPageView,
  setUserProperty,
  useAnalyticsEventTracker,
  selectTracker,
};
